module.exports = __webpack_public_path__ + "static/media/Scientist.067680f4.jpg";